{
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-body": [
    {
      "type": 0,
      "value": "Mention an agent to instantly brainstorm ideas, draft content, and analyze data."
    }
  ],
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-headline": [
    {
      "type": 0,
      "value": "Your agents are ready to help"
    }
  ],
  "post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-primary-action": [
    {
      "type": 0,
      "value": "Got it"
    }
  ]
}